import {RegionModel} from './RegionModel';
import {LocalCustomerModel} from './LocalCustomerModel';
import {ResourcesUnitModel} from './ResourcesUnitModel';
import {ContractTypeModel} from './ContractTypeModel';
import {ProviderModel} from './ProviderModel';

export class DeltaChargesModel {

  id: number;
  numAnnoMese: number;
  numAnnoMeseRif: number;
  srv: string;
  region: RegionModel;
  servicesCountry: string;
  billingCountry: string;
  localCustomer: LocalCustomerModel;
  resourceUnit: ResourcesUnitModel;
  delta: number;
  contractType: ContractTypeModel;
  isDeltaSignificativo: number;
  isClaims: number;
  note: string;
  isRecovery: boolean;
  provider: ProviderModel;
  actualMonthCharge: number;
  calculatedMonthCharge: number;
  actualVolume: number;

  constructor(id?: number, numAnnoMeseRif?: number, srv?: string, region?: RegionModel, servicesCountry?: string,
              billingCountry?: string, localCustomer?: LocalCustomerModel, resourceUnit?: ResourcesUnitModel,
              delta?: number, contractType?: ContractTypeModel, note?: string, provider?: ProviderModel, isRecovery?: boolean,
              actualMonthCharge?: number, calculatedMonthCharge?: number, actualVolume?: number) {
    this.id = id;
    this.numAnnoMeseRif = numAnnoMeseRif;
    this.srv = srv;
    this.region = region;
    this.servicesCountry = servicesCountry;
    this.billingCountry = billingCountry;
    this.localCustomer = localCustomer;
    this.resourceUnit = resourceUnit;
    this.delta = delta;
    this.contractType = contractType;
    this.note = note;
    this.provider = provider;
    this.isRecovery = isRecovery;
    this.actualMonthCharge = actualMonthCharge;
    this.calculatedMonthCharge = calculatedMonthCharge;
    this.actualVolume = actualVolume
  }

}

export class DeltaChargesReportModel extends  DeltaChargesModel {
  numAnnoMeseFrom: number;
  numAnnoMeseTo: number;
}
